import { Component, OnInit, Input } from '@angular/core';

export enum StatusBadge {
  Empty = "empty",
  Started = "started",
  Complete = "complete",
  Failed = "failed"
}

@Component({
  selector: '[app-status-icon]',
  templateUrl: './status-icon.component.html',
  styleUrls: ['./status-icon.component.scss']
})
export class StatusIconComponent implements OnInit {

  @Input() status?: string;
  @Input() size?: string;

  cssClasses: string;

  constructor() { }

  ngOnInit() { this.updateCSS(); }

  ngOnChanges() { this.updateCSS(); }

  updateCSS() {
    if (this.status === 'empty') this.cssClasses = 'empty';
    if (this.status === 'started') this.cssClasses = 'bg-warning';
    if (this.status === 'complete') this.cssClasses = 'bg-success';
    if (this.status === 'failed') this.cssClasses = 'bg-danger';
    if (this.size === 'small') this.cssClasses += ' small';
  }

}
